var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('div',[_c('router-view')],1):_c('div',[_vm._v(" Carregando... ")])}
var staticRenderFns = []

export { render, staticRenderFns }